import { ObtenerEstadoSuscripcionPorTipoVenta } from '../../../Helpers/ObtenerEstadoSuscripcionPorTipoDeVenta';

export const getSuscripcionesHabilitadas = (suscripciones, planes) => {
    return suscripciones.filter((s) => ObtenerEstadoSuscripcionPorTipoVenta(s,planes) === 0);
};
